import { manageVehiclesActions } from './manageVehiclesActionCreator';

const initialState = {
  filters: {
    legType: null,
    partnerType: null,
    vendorName: null,
    vendorId: null
  },
  pageNumber: 0,
  pageSize: 10,
  isLoading: false,
  isLoaded: false,
  allVehiclesData: {},
  newVehicleAdded: false,
  uploadedFiles: null,
  vehicleTypesOptions: null,
  isModalOpen: false,
  toEditVehicle: null,
  vehicleS3Urls: []
};

const manageVehiclesReducer = (state = initialState, action) => {
  switch (action.type) {
    case manageVehiclesActions.FETCH_ALL_VEHICLES: {
      return Object.assign({}, state, action.payload);
    }

    case manageVehiclesActions.UPDATE_PAGE_NUMBER: {
      return Object.assign({}, state, { pageNumber: action.payload });
    }

    case manageVehiclesActions.TOGGLE_MODAL_STATE: {
      return Object.assign({}, state, action.payload);
    }

    case manageVehiclesActions.EDIT_VEHICLE_DATA: {
      return Object.assign({}, state, action.payload);
    }

    case manageVehiclesActions.UPDATE_VEHICLE_DATA: {
      return Object.assign({}, state, action.payload);
    }

    case manageVehiclesActions.IMAGE_FILE_UPLOADED: {
      const imageFiles = action.payload.imageFileType
        ? { [action.payload.imageFileType]: action.payload.fileUrl }
        : {};

      return Object.assign({}, state, {
        uploadedFiles: {
          ...state.uploadedFiles,
          ...imageFiles
        },
        isLoaded: action.payload.isLoaded,
        isLoading: action.payload.isLoading
      });
    }

    case manageVehiclesActions.VEHICLE_IMAGES_UPLOADED: {
      let vehicleS3UrlsNew = [...state.vehicleS3Urls];
      if (action.payload.vehicleS3Urls) {
        vehicleS3UrlsNew.push(action.payload.vehicleS3Urls);
      }

      return Object.assign({}, state, {
        vehicleS3Urls: vehicleS3UrlsNew
      });
    }

    case manageVehiclesActions.ADD_NEW_VEHICLE: {
      return Object.assign({}, state, action.payload);
    }

    case manageVehiclesActions.DELETE_VEHICLE_IMAGE: {
      return Object.assign({}, state, action.payload);
    }

    case manageVehiclesActions.GET_VEHICLE_TYPES: {
      return Object.assign({}, state, action.payload);
    }

    case manageVehiclesActions.GET_VENDOR_NAMES: {
      return Object.assign({}, state, action.payload);
    }

    case manageVehiclesActions.UPDATE_FILTER_FIELDS: {
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload }
      });
    }

    default: {
      return state;
    }
  }
};

export default manageVehiclesReducer;
